'use client'

import { useEffect, useRef } from 'react'
import Lenis from 'lenis'

/**
 * Smooth-Scroll-Provider. R100.57 (2026-05-30): auf Mobile + auf langen Pages
 * (Legal-Texte) komplett deaktiviert — Lenis-rAF-Loop hat dort sichtbaren
 * Scroll-Lag erzeugt (Stephans Bug-Report 2026-05-30). Native Scroll ist
 * dort schneller + zuverlässiger.
 *
 * Verhalten:
 *   - reduced-motion: kein Lenis (wie vorher)
 *   - viewport < 768 px: kein Lenis (Mobile-Lag)
 *   - sonst:  Lenis mit duration 0.9s (statt 1.1s) und sanfterem multiplier
 */
export function LenisProvider({ children }: { children: React.ReactNode }) {
  const rafRef = useRef<number | null>(null)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    if (reduce) return
    if (window.innerWidth < 768) return

    const lenis = new Lenis({
      duration: 0.9,
      easing: (t) => 1 - Math.pow(1 - t, 4),
      smoothWheel: true,
      wheelMultiplier: 0.8,
      touchMultiplier: 1.2,
    })

    function raf(time: number) {
      lenis.raf(time)
      rafRef.current = requestAnimationFrame(raf)
    }
    rafRef.current = requestAnimationFrame(raf)

    return () => {
      if (rafRef.current != null) cancelAnimationFrame(rafRef.current)
      lenis.destroy()
    }
  }, [])

  return <>{children}</>
}
